import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type { StockResponseDTO, StockSearchParams } from "../types/stock.types";

export const stockService = {
  list: async (
    params?: StockSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<StockResponseDTO>> => {
    const response = await api.get<PageResponseDTO<StockResponseDTO>>(
      API_ENDPOINTS.STOCKS_USER.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<StockResponseDTO> => {
    const response = await api.get<StockResponseDTO>(
      API_ENDPOINTS.STOCKS_USER.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },
};
